import React, { Fragment, useState } from "react";
import {
    DocumentScannerOutlined,
    ExitToApp,
    FolderOpenOutlined,
    HowToReg,
    KeyboardArrowDown,
    Person,
    Settings,
} from "@mui/icons-material";
import { Button } from "@mui/material";
import { UserAccountWidgetMenu } from "../../../common/component/user-account-widget/user-account-widget-menu";
import { UserAccountWidgetMenuItem } from "../../../common/component/user-account-widget/user-account-widget-menu-item";
import { t } from "i18next";

import "./style.scss";

interface IUserAccountWidgetProps {
    name: string;
    logoutText: string;
    onSettingsOpen?: () => void;
    onBarcodeTestPageOpen?: () => void;
    onBusinessDocumentationOpen?: () => void;
    onContactDetailsValidationOpen?: () => void;
    onLogout: () => Promise<void>;
}

export const UserAccountWidget = (props: IUserAccountWidgetProps) => {
    const [userAccountWidgetMenuAnchor, setUserAccountWidgetMenuAnchor] = useState<HTMLElement | null>(null);

    const handleContactDetailsValidationOpen = () => {
        if (props.onContactDetailsValidationOpen) {
            props.onContactDetailsValidationOpen();
        }

        setUserAccountWidgetMenuAnchor(null);
    };

    return <Fragment>
        <Button variant={"outlined"}
                className={"user-account-selector__button"}
                color={userAccountWidgetMenuAnchor === null ? "inherit" : "secondary"}
                data-testid={"user-account-selector"}
                onClick={event => setUserAccountWidgetMenuAnchor(event.currentTarget)}
                startIcon={<Person />}
                endIcon={<KeyboardArrowDown />}
                size={"large"}>
            {props.name}
        </Button>
        {userAccountWidgetMenuAnchor && <UserAccountWidgetMenu anchor={userAccountWidgetMenuAnchor}
                                                               onClose={() => setUserAccountWidgetMenuAnchor(null)}>
            {props.onSettingsOpen && <UserAccountWidgetMenuItem label={"Settings"}
                                                                propertyKey={"settings"}
                                                                icon={<Settings />}
                                                                onClick={props.onSettingsOpen} />}
            {props.onBusinessDocumentationOpen && <UserAccountWidgetMenuItem label={t("navigation.businessDocumentation")}
                                       propertyKey={"businessDocumentation"}
                                       icon={<FolderOpenOutlined />}
                                       onClick={props.onBusinessDocumentationOpen} />}
            {props.onBarcodeTestPageOpen && <UserAccountWidgetMenuItem label={t("navigation.settings.barcodeTestPage.button")}
                                                                             propertyKey={"barcodeTestPage"}
                                                                             icon={<DocumentScannerOutlined />}
                                                                             onClick={props.onBarcodeTestPageOpen} />}
            {props.onContactDetailsValidationOpen && <UserAccountWidgetMenuItem label={"Validate contact details"}
                                                                             propertyKey={"contactDetails"}
                                                                             icon={<HowToReg />}
                                                                             onClick={handleContactDetailsValidationOpen} />}

            <UserAccountWidgetMenuItem label={props.logoutText}
                                       propertyKey={"logout"}
                                       icon={<ExitToApp />}
                                       onClick={props.onLogout} />
        </UserAccountWidgetMenu>}
    </Fragment>;
};
